"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroup = exports.Radio = exports.RadioState = exports.Description = exports.Label = exports.TopLabel = exports.Fieldset = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Media = require("../../Media");

var _motion = require("../../../../style/motion");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Fieldset = _styledComponents["default"].fieldset.withConfig({
  displayName: "Radiostyled__Fieldset",
  componentId: "sc-1o77bru-0"
})(["border:none;padding:0;margin:0;"]);

exports.Fieldset = Fieldset;

var TopLabel = _styledComponents["default"].legend.withConfig({
  displayName: "Radiostyled__TopLabel",
  componentId: "sc-1o77bru-1"
})(["display:block;color:var(--topLabelColor);font-size:1rem;margin-bottom:4px;", " ", " strong{font-weight:600;}"], function (_ref) {
  var theme = _ref.theme;

  switch (theme.mode) {
    case 'light':
      return (0, _styledComponents.css)(["--topLabelColor:var(--colors-athensGray);"]);

    default:
    case 'dark':
      return (0, _styledComponents.css)(["--topLabelColor:var(--brandPrimary);"]);
  }
}, function (_ref2) {
  var hasError = _ref2.hasError;
  return hasError && (0, _styledComponents.css)(["--topLabelColor:var(--colors-redPink);"]);
});

exports.TopLabel = TopLabel;

var Label = _styledComponents["default"].div.withConfig({
  displayName: "Radiostyled__Label",
  componentId: "sc-1o77bru-2"
})(["color:inherit;", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.body;
});

exports.Label = Label;

var Description = _styledComponents["default"].div.withConfig({
  displayName: "Radiostyled__Description",
  componentId: "sc-1o77bru-3"
})(["", ";", ""], function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.bodySM;
}, function (_ref5) {
  var theme = _ref5.theme;

  switch (theme.mode) {
    case 'light':
      return (0, _styledComponents.css)(["color:var(--colors-athensGray);"]);

    default:
    case 'dark':
      return (0, _styledComponents.css)(["color:var(--colors-lynch);"]);
  }
});

exports.Description = Description;

var RadioState = _styledComponents["default"].span.withConfig({
  displayName: "Radiostyled__RadioState",
  componentId: "sc-1o77bru-4"
})(["display:block;position:relative;border:2px solid;border-radius:100%;height:24px;width:24px;", " transition-duration:0.1s;&::before{content:'';display:block;position:absolute;content:'';border-radius:100%;height:8px;width:8px;top:50%;left:50%;margin:auto;transform:translate(-50%,-50%);", " transition-duration:0.1s;}", ""], (0, _motion.sharedTransition)('background, border-color'), (0, _motion.sharedTransition)('background, border-color'), function (_ref6) {
  var theme = _ref6.theme;

  switch (theme.mode) {
    case 'light':
      return (0, _styledComponents.css)(["border-color:rgba(255,255,255,0.2);input:checked ~ &{background:var(--brandPrimary);border-color:rgba(255,255,255,0.5);}input:checked ~ &::before{background:var(--colors-turquoise);}"]);

    default:
    case 'dark':
      return (0, _styledComponents.css)(["border-color:var(--colors-pigeon);&:hover{background-color:var(--colors-catskillWhite);}input:checked ~ &:hover{background-color:var(--colors-selago);}input:checked ~ &{border-color:var(--colors-irisBlue);}input:checked ~ &::before{background:var(--colors-irisBlue);}input:focus ~ &{box-shadow:0 0 0 3px ", ";}input:checked:focus ~ &{box-shadow:0 0 0 3px ", ";}"], theme.colors.pigeon_15, theme.colors.irisBlue_15);
  }
});

exports.RadioState = RadioState;
var Radio = (0, _styledComponents["default"])(_Media.Media).withConfig({
  displayName: "Radiostyled__Radio",
  componentId: "sc-1o77bru-5"
})(["--mediaObjectSpacing:12px;position:relative;align-items:center;cursor:pointer;& + &{margin-top:16px;}> ", "{display:flex;}input{position:absolute;opacity:0;}", ";"], _Media.MediaObject, function (_ref7) {
  var theme = _ref7.theme,
      hasDescription = _ref7.hasDescription;
  return hasDescription && (0, _styledComponents.css)(["align-items:flex-start;", "{transform:translateY(2px);}", "{", ";}"], RadioState, Label, theme.typography.bodyMedium);
});
exports.Radio = Radio;

var RadioGroup = _styledComponents["default"].div.withConfig({
  displayName: "Radiostyled__RadioGroup",
  componentId: "sc-1o77bru-6"
})(["display:flex;flex-direction:", ";margin:24px 0 0;> ", " + ", "{", "}"], function (_ref8) {
  var $direction = _ref8.$direction;
  return $direction;
}, Radio, Radio, function (_ref9) {
  var $direction = _ref9.$direction;

  switch ($direction) {
    default:
    case 'row':
      return (0, _styledComponents.css)(["margin-top:0;margin-left:20px;"]);

    case 'column':
      return (0, _styledComponents.css)(["margin-top:20px;"]);
  }
});

exports.RadioGroup = RadioGroup;